import React from "react";
import AppDispatcher from "dispatchers/app-dispatcher";
import * as ReactRedux from "react-redux";
import Spinner from "util/components/spinner";
import Text from "util/components/text";

class CustomerSuccessAdminEntries extends React.Component {
  state = {
    entry: "",
    loading: false,
  };

  componentDidMount() {
    this.findEntry();
  }

  findEntry = () => {
    this.setState({
      loading: true,
    });
    AppDispatcher.http({
      url: `/cs-entries-email`,
      success: (res) => {
        this.setState({
          entry: res,
          loading: false,
        });
      },
    });
  };

  render() {
    if (this.state.loading) {
      return <Spinner />;
    }

    return (
      <div className="row">
        <div className="col-xs-12">Last Email Received: {this.state.entry}</div>
      </div>
    );
  }
}

const mapState = function (state) {
  return state;
};

export default ReactRedux.connect(mapState)(CustomerSuccessAdminEntries);
